import React, { useEffect, useState } from "react";
import { Trash2, RotateCcw, Inbox } from "lucide-react";
import { jobsApi, formatApiError } from "../lib/api";
import { toast } from "sonner";
import StatusBadge from "../components/StatusBadge";
import { formatDateDMY } from "../lib/format";

export default function TrashPage() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try { setJobs(await jobsApi.listTrashed()); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); }, []);

  const handleRestore = async (j) => {
    try { await jobsApi.restore(j.id); toast.success("Återställt"); refresh(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const handlePermanent = async (j) => {
    if (!window.confirm(`Permanent radera ärende för ${j.customerName}?\n\nDetta går INTE att ångra.`)) return;
    try { await jobsApi.deletePermanent(j.id); toast.success("Permanent raderat"); refresh(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 pb-24 fade-in-up">
      <div className="flex items-center gap-3 mb-2">
        <span className="inline-flex items-center justify-center rounded-xl p-2.5 bg-red-500">
          <Trash2 className="h-5 w-5 text-white" />
        </span>
        <div>
          <h1 className="text-3xl font-bold display-tight"
              style={{ fontFamily: "Manrope, sans-serif", color: "#0F172A" }}
              data-testid="trash-title">
            Papperskorg
          </h1>
          <p className="text-slate-500 text-sm mt-1.5">
            Endast administratör kan återställa eller permanent radera.
          </p>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-16 text-slate-400">Laddar…</div>
      ) : jobs.length === 0 ? (
        <div className="text-center py-20 text-slate-500">
          <Inbox className="h-12 w-12 mx-auto mb-3 text-slate-300" />
          <p>Papperskorgen är tom.</p>
        </div>
      ) : (
        <div className="soft-card p-4 mt-6">
          <ul className="divide-y divide-slate-100">
            {jobs.map((j) => (
              <li key={j.id} data-testid={`trash-row-${j.id}`}
                  className="flex flex-wrap items-center justify-between gap-3 py-4 px-2">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-semibold text-slate-900">{j.customerName}</span>
                    <StatusBadge status={j.status} />
                  </div>
                  <div className="text-xs text-slate-500">
                    {j.device} · {formatDateDMY(j.date)} · Flyttad av {j.deletedBy || "okänd"}
                  </div>
                </div>
                <div className="flex gap-2">
                  <button onClick={()=>handleRestore(j)}
                          data-testid={`restore-${j.id}`}
                          className="press-feedback inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 hover:bg-emerald-100 min-h-[36px]">
                    <RotateCcw className="h-3.5 w-3.5" /> Återställ
                  </button>
                  <button onClick={()=>handlePermanent(j)}
                          data-testid={`permanent-${j.id}`}
                          className="press-feedback inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold bg-red-50 text-red-700 hover:bg-red-100 min-h-[36px]">
                    <Trash2 className="h-3.5 w-3.5" /> Radera permanent
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
